module.exports = __webpack_public_path__ + "asset/image/operate-ab2c.svg";